import { RootState } from "@app/redux/root-reducer";

export const selectViewState = (store: RootState) =>
  store.viewsReducer.views;
export const selectGetReviewsState = (store: RootState) =>
  store.viewsReducer.getReviews;
export const selectAvgReviewsState = (store: RootState) =>
  store.viewsReducer.getAvgReviews;
export const selectAddReviewState = (store: RootState) => 
  store.viewsReducer.addReview